import { Dialog, DialogContentText, useMediaQuery } from "@mui/material";
import React from "react";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { verbalTheme } from "../layout/themes/verbal.theme";

type SubscriptionExpiredDialogProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
};

export const SubscriptionExpiredDialog = (props: SubscriptionExpiredDialogProps): JSX.Element => {
    const { open, setOpen } = props;
    const fullScreen = useMediaQuery(verbalTheme.breakpoints.down("lg"));

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullScreen={fullScreen}>
            <MuiDialogTitle>Subscription Expired</MuiDialogTitle>
            <MuiDialogContent>
                <DialogContentText>
                    Please renew your subscription to continue using Verbal Wellbeing{" "}
                </DialogContentText>
            </MuiDialogContent>
        </Dialog>
    );
};
